/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { Divider } from '@coursera/cds-core';

import EnrollmentDiaglogEventingContext from 'bundles/degree-home/components/v3-dpm/components/EnrollmentDialog/EnrollmentDiaglogEventingContext';
import AcademicTermsCourseCard from 'bundles/degree-home/components/v3-dpm/components/PlanningTool/AcademicTermsCourseCard';
import NoCoursesCard from 'bundles/degree-home/components/v3-dpm/components/PlanningTool/NoCoursesCard';
import type { TermStatus } from 'bundles/degree-home/components/v3-dpm/components/PlanningTool/lib/academicTermTypes';
import type { UseCurriculum_PersonalizedSegmentCourseFragment as SegmentCourse } from 'bundles/degree-home/components/v3-dpm/lib/__queries__/__generated__/dpmSharedFragments';

type Props = {
  termName: string;
  termStatus: TermStatus;
  termId?: string;
  courses?: Array<SegmentCourse>;
};

const styles = {
  separatorCard: () => css`
    margin-bottom: var(--cds-spacing-100);
    margin-top: var(--cds-spacing-100);
  `,
  separatorHeader: () => css`
    margin-bottom: var(--cds-spacing-100);
  `,
};

const AcademicTermsCourseCardRenderer: React.VFC<Props> = ({ termId, termName, courses, termStatus }) => {
  if (!courses?.length) {
    return <NoCoursesCard />;
  }

  return (
    <React.Fragment>
      <Divider css={styles.separatorHeader} color="light" />
      {courses.map((course: SegmentCourse, index: number) => {
        return (
          <React.Fragment key={course.segmentCourse.id}>
            <EnrollmentDiaglogEventingContext termName={termName} segmentCourse={course.segmentCourse}>
              <AcademicTermsCourseCard termId={termId} course={course} termStatus={termStatus} />
            </EnrollmentDiaglogEventingContext>

            {index < courses.length - 1 && <Divider css={styles.separatorCard} color="light" />}
          </React.Fragment>
        );
      })}
    </React.Fragment>
  );
};

export default AcademicTermsCourseCardRenderer;
